import { DEFAULT_GC_TIME, DEFAULT_STALE_TIME } from '@/client/constants';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import useGetQueryFn from '../use-get-query-fn';

export interface QuickReplyItem {
  reply_id: string;
  title: string;
  body: string;
  category?: string;
  created_at: number;
  updated_at: number;
}

type QueryResponse = {
  status: number;
  data: {
    quick_replies: QuickReplyItem[];
    total_count: number;
    limit: number;
    offset: number;
  };
};

export const createListQuickRepliesKey = (additional: any[] = []) => [
  'list-quick-replies',
  ...additional,
];

export const useListQuickRepliesQuery = (additionalProps = {}) => {
  const queryFn = useGetQueryFn<QueryResponse>({
    defaultErrorMessage: 'An unexpected error occurred while listing quick replies',
    endpoint: `/api/admin/whatsapp/quick-replies`,
  });

  return useQuery({
    queryKey: createListQuickRepliesKey([additionalProps]),
    queryFn: () => queryFn({ ...additionalProps }),
    staleTime: DEFAULT_STALE_TIME,
    gcTime: DEFAULT_GC_TIME,
    placeholderData: keepPreviousData,
  });
};
